import { h } from 'preact';
export const Framer = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7" })));
};
//# sourceMappingURL=framer.js.map